import React from "react";
import "./Hero.css";
import Logo from "../../assets/imgs/logo-1-1024x240.png";
import Livro from "../../assets/imgs/Ebook-1-808x1024 (1).webp";
import LivroMobile from "../../assets/imgs/Ebook-1-808x1024-_1_.webp";
function Hero({ onScroll }) {
  const isMobile = window.innerWidth < 430;
  return (
    <>
      <div className="hero-container">
        <div className="hero-content">
          <img src={Logo} alt="insigne"></img>
          <h1>Precisa de ajuda para seu Trabalho Acadêmico?</h1>
          <p>
            Com a Plataforma Insigne de Pesquisa, essa confusão é coisa do
            passado! Tenha um passo a passo claro para você escrever{" "}
            <span>QUALQUER</span> trabalho acadêmico, de artigos a teses,
            garantindo nota máxima sem estresse.
          </p>

          <button onClick={onScroll} className="main-btn alt">
            Preciso de ajuda com o meu trabalho
          </button>
        </div>

        <div>
          {isMobile ? (
            <img src={LivroMobile} alt="insigne"></img>
          ) : (
            <img src={Livro} alt="insigne"></img>
          )}
        </div>
      </div>
      <div className="orange-line"></div>
    </>
  );
}

export default Hero;
